import { PageNotice } from "@/app/errors/PageNotice";
import { useTranslation } from "@/shared/i18n/LocaleProvider";

export function NoAccessPage() {
  const { t } = useTranslation();

  return <PageNotice line={t("noAccess.line")} back={t("noAccess.back")} />;
}
